export var borders = {
  borderRadius: '4px',
  buttonRadius: '4px'
};
export var legacyBorders = {
  borderRadius: '0',
  buttonRadius: '10em' // arbitrarily large for the pill shape

};